import { JsonLd } from '../Constants';
import { owl } from '../Vocabs';
import Resource from './Resource';
import { Mixin } from './Mixins/Class';
export default class extends Mixin(Resource) {
    constructor(apiDocs) {
        super({
            [JsonLd.Id]: owl.Nothing,
        });
        this.__apiDocs = apiDocs;
    }
    get title() {
        return 'Nothing';
    }
    get description() {
        return 'Nothing';
    }
    get operations() {
        return [];
    }
    get apiDocumentation() {
        return this.__apiDocs;
    }
    getCollections() {
        return [];
    }
    getLinks() {
        return [];
    }
    getProperties() {
        return [];
    }
    load() {
        return Promise.reject(new Error('Method not implemented.'));
    }
    findOperations() { return []; }
    findOperationsDeep() { return []; }
    getOperationsDeep() { return []; }
}
//# sourceMappingURL=Nothing.js.map